/**
 * Created by Josef Jurca on 6.3.2017.
 */

import {
    convertForGetLinearChannels,
    convertFromGetLinearChannels
} from '../adapters/linearchannels';

import LinearChannels from 'models/linearchannels';

import {isValidResponse} from '../validators/linearchannels';

import {getInstance as getStore} from 'store/store';
import {setLinearChannels} from 'store/actions/linearchannels';

/**
 * Returns asset collection with ID.
 *
 * @param {string} linearTypeId - Linear type id.
 * @returns {Promise} Promise that resolves to viewTree.
 */
export function getLinearChannels (linearTypeId) {

    const url = this._baseUrl + this._endPoints.assetList,
        store = getStore();

    return this.read(
        {
            url: url,
            data: convertForGetLinearChannels.call(this, linearTypeId)
        })
        .then(response => {
            let linearChannels;

            if (!isValidResponse(response)) {
                return;
            }

            linearChannels = new LinearChannels(convertFromGetLinearChannels.call(this, response));
            store.dispatch(setLinearChannels(linearChannels.getChannels()));

            return linearChannels;
        });
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/linearchannels.js